import { DetailBar as AntdDetailBar } from "@empglabs/backoffice-ui-kit"

export default function DetailBar(props) {
  return <AntdDetailBar {...props} />
}
